/**
 * @group Utils
 *
 * @summary
 * <blockquote>Extracts headers from a fetch Response into a plain object.</blockquote>
 *
 * Converts the Headers iterator into a simple key-value record for easier access and serialization.
 *
 * @example
 * ```typescript
 * import { extractHeaders } from '@shared/httpService';
 *
 * const response = await fetch('/api/data');
 * const headers = extractHeaders(response);
 *
 * console.log(headers['content-type']); // 'application/json'
 * console.log(headers['cache-control']); // 'no-cache'
 * ```
 *
 * @param response - The fetch Response object
 * @returns A plain object containing all response headers as key-value pairs
 */
export function extractHeaders(response: Response): Record<string, string> {
  const headers: Record<string, string> = {};
  response.headers.forEach((value, key) => {
    headers[key] = value;
  });
  return headers;
}

